module.exports = __webpack_public_path__ + "img/tip.9477c5e5.svg";